import { useEffect, useState } from "react";
import { Button, Checkbox, Divider, Form, Modal, Radio, Select } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import toast from "react-hot-toast";

const CustomizeAddProduct = ({
  isOpen,
  onOk,
  onCancel,
  itemData,
  vendorId,
}) => {
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductErr, setSelectedProductErr] = useState("");
  const [productList, setProductList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [uomListErr, setUomListErr] = useState("");
  const [modifireList, setModifireList] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  //get Product List by vendor Id
  const getProductList = async (vendorId) => {
    dispatch(changeLoader(true));
    try {
      let params = {};
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_PRODUCT_LIST_BY_VENDOR + "/" + vendorId,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (apiResponse?.data?.data) {
          let lists = [];
          for (let item of apiResponse?.data?.data) {
            lists.push({ value: item.id, label: item.productLocales[0].name });
            if (item?.id === itemData.product_id)
              setSelectedProduct({
                value: item.id,
                label: item.productLocales[0].name,
              });
          }
          setProductList(lists);
        }
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };
  useEffect(() => {
    getProductList(vendorId);
    if (itemData?.product_id > 0) {
      //call get uom list api
      handleProductSelect(itemData?.product_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemData, vendorId]);

  const handleProductSelect = async (productId) => {
    dispatch(changeLoader(true));
    try {
      //set selected product
      for (let item of productList) {
        if (item.value === productId)
          setSelectedProduct({ value: item.value, label: item.lable });
      }

      let params = {};
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_PRODUCT_UOM_LIST + "/" + productId,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (apiResponse?.data?.data) {
          let itemList = [];
          for (let item of apiResponse?.data?.data) {
            let name = "";
            for (let itm of item.productUomLocales) {
              if (itm.languageCode === "en") name = itm.name;
            }
            let image = "";
            for (let itm of item.productUomImages) {
              if (itm.featured === 1 || itm.featured === '1') image = itm.image;
            }

            itemList.push({
              id: item.id,
              price: item.price,
              name: name,
              image: image,
              isChecked:
                itemData.uom_id && itemData.uom_id === item.id ? true : false,
            });
          }
          setUomList(itemList);
          setSelectedProductErr("");
          if (itemData.uom_id) handleUomSelect(itemData.uom_id);
        }
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const handleUomSelect = async (uomId) => {
    dispatch(changeLoader(true));
    try {
      let params = {};
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_UOM_MODIFIRE_LIST + "/" + uomId,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (apiResponse?.data?.data) {
          let itemList = [];
          for (let item of apiResponse?.data?.data) {
            let name = "";
            for (let itm of item?.modifierGroup?.modifierGroupLocales) {
              if (itm.languageCode === "en") name = itm.name;
            }
            let option = [];
            for (let itm of item?.productUomModifierItems) {
              let isChecked = false;

              if (itemData.modifier_details) {
                for (let row of itemData.modifier_details) {
                  if (row.product_modifier_id === item.id) {
                    for (let rowData of row.modifier_items) {
                      if (rowData.product_modifier_item_id === itm.id)
                        isChecked = true;
                    }
                  }
                }
              }

              option.push({
                id: itm.id,
                name: itm?.modifierGroupItem?.modifierGroupItemLocales[0]?.name,
                price: itm?.modifierGroupItem?.price,
                isChecked: isChecked,
              });
            }
            itemList.push({
              id: item.id,
              type: item?.modifierGroup?.type,
              name: name,
              min: item?.modifierGroup?.min,
              max: item?.modifierGroup?.max,
              option: option,
              error: "",
            });
          }
          setModifireList(itemList);
        }
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const onRadioChange = (e) => {
    const selectedId = e.target.value;

    // Update `isChecked` for the selected item
    const updatedList = uomList.map((item) => ({
      ...item,
      isChecked: item.id === selectedId, // Set true for selected item, false for others
    }));

    setUomListErr("");
    setUomList(updatedList);
    handleUomSelect(selectedId);
  };

  // Handle radio selection
  const handleRadioChange = (itemId, selectedId) => {
    const updatedList = modifireList.map((item) => {
      if (item.id === itemId) {
        const updatedOptions = item.option.map((opt) => ({
          ...opt,
          isChecked: opt.id === selectedId, // Set true only for selected radio
        }));
        return { ...item, option: updatedOptions, error: "" };
      }
      return item;
    });
    setModifireList(updatedList);
  };

  // Handle checkbox selection
  const handleCheckboxChange = (itemId, optionId, isChecked) => {
    const updatedList = modifireList.map((item) => {
      if (item.id === itemId) {
        const updatedOptions = item.option.map((opt) =>
          opt.id === optionId ? { ...opt, isChecked: isChecked } : opt
        );
        return { ...item, option: updatedOptions, error: "" };
      }
      return item;
    });
    setModifireList(updatedList);
  };

  const calculateTotalAmount = () => {
    let amount = 0;
    for (let item of uomList) {
      if (item.isChecked && item.price) amount = amount + item.price;
    }
    for (let item of modifireList) {
      for (let row of item.option) {
        if (row?.isChecked && row.price) amount = amount + row.price;
      }
    }
    setTotalAmount(amount);
  };

  useEffect(() => {
    calculateTotalAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uomList, modifireList]);

  //--------------------------------------------------------------------
  // const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const handleContinue = () => {
    //onCancel();
    //setIsSecondModalOpen(true);

    //product check and validation
    if (Object.keys(selectedProduct).length === 0) {
      setSelectedProductErr("Product is required");
      return false;
    }

    //uom check and validation
    let tokan = true;
    let count = 0;
    for (let row of uomList) {
      if (row.isChecked) {
        tokan = false;
        count = count + 1;
      }
    }
    if (tokan) {
      setUomListErr("Please choose any variant");
      return false;
    }

    //modifireList check and validation
    let checkTokan = false;
    for (let i in modifireList) {
      let row = modifireList[i];
      let tokan = true;
      let count = 0;
      for (let itm of row.option) {
        if (itm.isChecked) {
          tokan = false;
          count = count + 1;
        }
      }
      let errorMsg = "";
      if (row.min > 0 && tokan) {
        errorMsg = `You need to select minimum ${row.min} option`;
      }
      if (row.min > count) {
        errorMsg = `You need to select minimum ${row.min} option`;
      }
      if (row.max < count) {
        errorMsg = `You can select only maximum ${row.max} option`;
      }
      if (errorMsg !== "") {
        checkTokan = true;
        setModifireList((prevList) => {
          let allModifiers = [...prevList];
          let singleModifier = allModifiers[i];
          let updateModifier = {
            ...singleModifier,
            error: errorMsg,
          };
          allModifiers[i] = updateModifier;
          return allModifiers;
        });
      }
    }
    if (checkTokan) return false;

    //set selected uom id
    let uomId = 0;
    for (let row of uomList) {
      if (row.isChecked) uomId = row.id;
    }
    // set modifier_details
    let modifier_details = [];
    for (let row of modifireList) {
      let token = false;
      let itemDetail = [];
      for (let itm of row.option) {
        if (itm.isChecked) {
          itemDetail.push({ product_modifier_item_id: itm.id });
          token = true;
        }
      }
      if (token) {
        modifier_details.push({
          product_modifier_id: row.id,
          modifier_items: itemDetail,
        });
      }
    }
    //set product
    let product = null;
    if (Object.keys(selectedProduct).length > 0) {
      //find product img
      let img = "";
      for (let row of uomList) {
        if (row.isChecked) img = row.image;
      }
      let productName = "";
      for (let row of productList) {
        if (row.value === selectedProduct.value) productName = row.label;
      }
      let uomName = "";
      for (let row of uomList) {
        if (row.isChecked) uomName = row.name;
      }
      let modifireName = [];
      for (let row of modifireList) {
        let token = false;
        let modifireNames = [];
        for (let opt of row.option) {
          if (opt.isChecked) {
            modifireNames.push(opt.name);
            token = true;
          }
        }

        if (token) {
          modifireName.push({
            modifireItem: row.name,
            modifireName: modifireNames.join(","),
          });
        }
      }

      product = {
        productImg: img,
        productName: productName,
        productUomName: uomName,
        totalAmount: totalAmount,
        modifireName: modifireName,
      };
    }

    let newItemData = {
      type: itemData.type,
      product_id: selectedProduct.value,
      uom_id: uomId,
      modifier_details: modifier_details,
      product: product,
    };
    onOk(newItemData);
  };

  return (
    <>
      <Modal
        title="Add Product"
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={onOk}
        footer={null}
      >
        <Form
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24, width: "100%" }}
          autoComplete="off"
        >
          <div className="w-full">
            <Select
              className="w-full"
              size="large"
              placeholder="Select"
              showSearch
              filterOption={(input, productList) =>
                (productList?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              {...(selectedProduct ? { value: selectedProduct } : {})}
              options={productList}
              onChange={(value) => {
                handleProductSelect(value);
              }}
            />
          </div>
          {selectedProductErr ? (
            <span className="text-red-100">{selectedProductErr}</span>
          ) : null}

          {uomList.length > 0 ? (
            <>
              <Divider className="bg-[#E5E7EB]" />
              <div className="flex justify-between items-center mb-5">
                <div className="relative">
                  <h6 className="font-semibold">Choose from variant</h6>
                  <p className="text-[#808080]">Choose any 1 option</p>
                </div>
                <Button icon={<CheckOutlined />}>Required</Button>
              </div>
              <div className="flex flex-col gap-2">
                {uomList.length > 0 ? (
                  <Radio.Group
                    onChange={onRadioChange}
                    value={uomList.find((item) => item.isChecked)?.id || null}
                    className="w-full"
                  >
                    {uomList.map((item, index) => (
                      <div
                        key={index}
                        className="flex justify-between items-center w-full"
                      >
                        <Radio
                          value={item.id}
                          className="w-full full-w-radio m-0"
                        >
                          <div className="w-full flex justify-between items-center gap-2">
                            <span>{item.name}</span>{" "}
                            <span>SAR {item.price}</span>
                          </div>
                        </Radio>
                        {/* {item.price > 0 && (
                                <span className="font-medium w-full flex">SAR {item.price}</span>
                              )} */}
                      </div>
                    ))}
                  </Radio.Group>
                ) : null}
              </div>
              {uomListErr ? (
                <span className="text-red-100">{uomListErr}</span>
              ) : null}
            </>
          ) : null}

          {modifireList.length > 0
            ? modifireList.map((item, index) => {
                return (
                  <>
                    <Divider className="bg-[#E5E7EB]" />
                    <div
                      key={index}
                      className="flex justify-between items-center mb-5"
                    >
                      <div className="relative">
                        <h6 className="font-semibold">{item.name}</h6>
                        <p className="text-[#808080]">
                          At least {item.min} min and {item.max} max options are
                          required to choose
                        </p>
                      </div>
                      {item.min > 0 ? (
                        <Button icon={<CheckOutlined />}>Required</Button>
                      ) : null}
                    </div>
                    {item.type === "single" ? (
                      item?.option?.length > 0 ? (
                        <Radio.Group
                          onChange={(e) =>
                            handleRadioChange(item.id, e.target.value)
                          }
                          value={
                            item.option.find((opt) => opt.isChecked)?.id || null
                          }
                          className="w-full"
                        >
                          {item?.option?.map((itm, ind) => (
                            <div key={ind} className="custom-radio-text">
                              <Radio
                                value={itm.id}
                                className="w-full full-w-radio m-0"
                              >
                                <div className="w-full flex justify-between items-center gap-2">
                                  <span>{itm.name}</span>
                                  <span>
                                    {itm.price > 0 && (
                                      <span className="font-medium">
                                        SAR {itm.price}
                                      </span>
                                    )}
                                  </span>
                                </div>
                              </Radio>
                            </div>
                          ))}
                        </Radio.Group>
                      ) : null
                    ) : item?.option?.length > 0 ? (
                      <div className="w-full">
                        {item?.option?.map((itm, ind) => (
                          <div
                            key={ind}
                            className="flex justify-between items-center w-full"
                          >
                            <Checkbox
                              checked={itm.isChecked}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  item.id,
                                  itm.id,
                                  e.target.checked
                                )
                              }
                               className=" w-full full-w-checkbox"
                            >
                               <div className="w-full flex justify-between items-center gap-2">
                               {itm.name}
                              {itm.price > 0 && (
                                <div className="font-medium">
                                  SAR {itm.price}
                                </div>
                              )}
                               </div>
                             
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    ) : null}
                    {item.error !== "" ? (
                      <span className="text-red-100">{item.error}</span>
                    ) : null}
                  </>
                );
              })
            : null}

          <Divider className="bg-[#E5E7EB]" />

          <div className="flex justify-between items-center">
            {totalAmount > 0 ? (
              <div className="text-[#222222]">
                Total Amount
                <div>SAR {totalAmount}</div>
              </div>
            ) : null}
            <Button
              type="primary"
              className="h-[39px]"
              onClick={handleContinue}
            >
              Continue
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default CustomizeAddProduct;
